module.exports = __webpack_public_path__ + "media/images/caret-up-c76ccfff395a5b4a8ec734fe531ed59c.svg";